import React, { useEffect, useRef, useState } from 'react';

import { convertSecondsToMinutesSeconds } from "../../services/utils";

import "./styles.scss";

function VideoPlayer({
    src,
    color = "white",
    poster // thumbnail opcional para o vídeo
}) {
    const videoRef = useRef();
    const [playing, setPlaying] = useState(false);
    const [progress, setProgress] = useState(0);
    const [speed, setSpeed] = useState(0);

    const speeds = [1, 1.5, 2];

    useEffect(() => {
        if (progress === 100 && playing) {
            setPlaying(false);
            setProgress(0);
            videoRef.current.currentTime = 0;
        }
    }, [progress, playing]);

    const togglePlayPause = () => {
        if (playing) {
            videoRef.current.pause();
        } else {
            videoRef.current.play();
        }
        setPlaying(!playing);
    };

    const updateProgress = () => {
        if (videoRef.current?.duration) {
            setProgress((videoRef.current.currentTime / videoRef.current.duration) * 100);
        }
    };

    const changeSpeed = (newSpeed) => {
        videoRef.current.playbackRate = speeds[newSpeed];
        setSpeed(newSpeed);
    };

    return (
        <div className="video-container" data-color={color}>
            <video
                ref={videoRef}
                onTimeUpdate={updateProgress}
                src={src}
                poster={poster}
                className="video-element"
                controls
            >
                Seu navegador não suporta o elemento de vídeo.
            </video>
{/* 
            <div className="video-inner">
                <button
                    className="play-button"
                    onClick={togglePlayPause}>
                    {playing ? "❚❚" : "▶"}
                </button>

                <div className="center">
                    <progress className="progress" value={progress} max="100"></progress>
                    <div className="times">
                        <p>{convertSecondsToMinutesSeconds(videoRef?.current?.currentTime || 0)}</p>
                        <p>{convertSecondsToMinutesSeconds(videoRef?.current?.duration || 0)}</p>
                    </div>
                </div>
                <button
                    className="speed"
                    onClick={() => changeSpeed(speed >= (speeds.length - 1) ? 0 : speed + 1)}
                >
                    {speeds[speed]}x
                </button>
            </div> */}
        </div>
    );
}

export default VideoPlayer;
